import { useContext } from 'react';

import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';
import { Button } from '@/common/styleguide/atoms/Button/Button';
import { ComingSoonDrawerContext } from '@/modules/HomePage/components/ComingSoon/ComingSoonDrawer/ComingSoonDrawerContext';

import styles from './comingSoonHeader.module.scss';

const ComingSoonHeader = () => {
  const { handleOpenDrawer } = useContext(ComingSoonDrawerContext);

  const handleSeeAllClick = () => {
    handleOpenDrawer();
    trackElementInteraction({ elementId: 'see_all_button', elementVariant: 'coming_soon' });
  };

  return (
    <>
      <div className={styles.headingWrapper}>
        <h2 className={styles.heading} data-testid="coming-soon-heading">
          Coming soon
        </h2>
        <Button className={styles.seeAll} onClick={handleSeeAllClick} variant="text">
          See all
        </Button>
      </div>
    </>
  );
};

export default ComingSoonHeader;
